import { useState } from "react";

/**
 * boolean値を扱うhookを簡略化
 */
export const useActivation = (defaultValue: boolean): [boolean, () => void, () => void] => {
  const [activated, setActivated] = useState<boolean>(defaultValue)
  return [activated, (): void => { setActivated(true) }, (): void => { setActivated(false) }]
}
